<template>
	<div class="px-lg-2" v-if="selectedLanguageIndex !== null && languages.length > 1">
		<div id="languagePicker">
			<button type="button" @click="uicontrol.extended = !uicontrol.extended">
				<div class="flag" v-html="languages[selectedLanguageIndex].flag"></div>
				<span>
				{{ languages[selectedLanguageIndex].iso_name }}
			</span>
			</button>
			<ul class="dropdown-menu" :class="{ 'visible' : uicontrol.extended }">
				<li v-for="(language, languageIndex) in languages" :index="languageIndex" :key="language.iso_693_1_code">
					<a class="dropdown-item d-flex" href="#" @click.prevent="setLanguage(languageIndex)" :class="{ 'd-none' : languageIndex === selectedLanguageIndex}">
						<div class="flag" v-html="language.flag"></div>
						<span>
						{{language.iso_name }}
					</span>
					</a>
				</li>
			</ul>
		</div>
	</div>

</template>

<script>

import { languages } from "~app_root/public/tv/app.config";

export default {
	name: 'LanguagePicker',
	data() {
		return {
			selectedLanguageIndex: null,
			languages : languages,
			uicontrol : {
				extended : false
			}
		}
	},
	mounted () {
		this.selectedLanguageIndex = this.languages.findIndex(language => language.iso_693_1_code === this.$page.props.locale)
	},
	methods: {
		setLanguage(languageIndex) {
			window.location.href = route('locale.set', this.languages[languageIndex].iso_693_1_code);
		}
	},
}
</script>